module.exports = {
  buttons: {
    backLink: "뒤로",
    cancelButton: "취소",
    chatWithAgentButton: "에이전트와 채팅",
    closeButton: "닫기",
    contactSupportButton: '<a href="" class="adsktm-show-contact-support-btn">지원 요청</a>',
    copiedButton: "복사됨",
    copyButton: "복사",
    getStartedButton: "시작하기",
    haveAQuestion: "질문이 있으십니까?",
    helpPanel: '<a target="_blank" href="https://knowledge.autodesk.com/ko/contact-support/installation-activation/activation-registration">질문이 있으십니까?</a>',
    nextButton: "다음",
    requiredLabel: "필수",
    restartButton: "다시 시작",
    signInButton: "로그인",
    submitAgainButton: "다시 제출",
    submitButton: "제출",
    tryAgainButton: "다시 시도",
    notNow: "나중에",
    validate: "유효성 검사"
  },
  signIn: {
    gatheringInfo: "계정 정보를 수집하는 중",
    helloUser: "<first-name>님, 안녕하세요!",
    justAMoment: "잠시만 기다려 주십시오 ...",
    signInNow: "<a>지금 로그인</a>",
    signInHelp: `<a target="_blank" href="https://knowledge.autodesk.com/ko/contact-support/account-management/account-creation-sign-profile-management">로그인하는 데 문제가 있으십니까?</a>`,
    startAccessAccount: "먼저 계정에 액세스합니다."
  },
  contactOptions: {
    addtlComments: "추가 설명(선택 사항)",
    addtlCommentsMsg: "위 상세 정보에 따라 케이스가 열립니다. 여기에 도움이 될 수 있는 추가 정보를 입력해 주십시오.",
    addtlCommentsReqd: "설명",
    agentAvailable: "에이전트를 이용할 수 있음",
    agentAvailableStdby: "에이전트를 이용할 수 없음 - 대기 ",
    agentUnavailable: "에이전트를 이용할 수 없음",
    cancelCase: "케이스 취소",
    cancelChat: "채팅 취소",
    caseConfirm1: "확인 이메일이 곧 전송됩니다. 이메일이 도착하지 않으면 정크/스팸 메일 폴더를 확인해 보십시오.",
    caseConfirm2: "에이전트가 케이스를 검토하고 2 영업일 내에 연락을 드릴 것입니다.",
    caseDetails: "케이스 상세 정보",
    caseNumber: "케이스 번호: <case-number>",
    caseSubmitted: "케이스 제출됨",
    chatWithAgent: "에이전트와 채팅",
    closingWindowMsg: "연결되기 전에 이 창을 닫으면 채팅이 취소될 수 있습니다.",
    connectMomentarily: "곧 연결됩니다.",
    createCase: "케이스 생성",
    errorLabel: "오류",
    forceStartChat: "<a>채팅을 시작하려면 여기를 클릭하십시오.</a>",
    getCaseAnswer2Days: "2일 안으로 답변이 제공됩니다.",
    mayCloseWindow: "이제 이 창을 닫아도 됩니다.",
    note: "참고:",
    orSubmitCase: "또는 <a>케이스를 제출<a/>하시면 담당자가 2 영업일 내에 연락을 드릴 것입니다.",
    popUpBlocker: "팝업 차단 기능을 사용하고 있습니까?",
    productLabel: "제품",
    sorryNoAgent: "죄송합니다. 에이전트를 이용할 수 없습니다.",
    willUpdateAgent: "에이전트를 이용할 수 있게 되는 즉시 화면이 업데이트됩니다.",
    yourContactInfo: "내 연락처 정보"
  },
  welcome: {
    important: "중요:",
    noteForTheUser: "참고:"
  },
  captchaScreen: {
    correctMsg: "맞았습니다.",
    incorrectMsg: "틀렸습니다. 다시 시도해 주십시오.",
    pageTitle: "보안 검사",
    typeCaptchaLabel: "위에 보이는 문자를 입력하십시오"
  },
  contactInfoScreen: {
    emailDisclaimer: "확인 이메일을 보내 드리기 위해 필요합니다.",
    emailTitle: "이메일",
    firstNamePlaceholder: "이름",
    lastNamePlaceholder: "성",
    nameLabel: "이름",
    pageTitle: "1. 연락처 정보"
  },
  reviewAccountInfo: {
    differentAccount: "<a>다른 계정으로 로그인</a>",
    emailConfirm: "귀하의 계정을 찾아 확인 이메일을 보내는 데 이 이메일이 사용됩니다.",
    helloUser: "<first-name>님, 안녕하세요!",
    pageTitle: "1. 계정 정보 검토",
    signedInAs: "다음 정보로 로그인하셨습니다."
  },
  processInfoScreen: {
    checkSerialMsg: "Enter 키를 눌러 이 일련 번호를 확인해 주십시오.",
    continueTyping: "XXX-XXXXXXXX 형식으로 일련 번호를 입력해 주십시오.",
    doNotNeedHula: "<strong>기쁜 소식을 전해 드립니다!</strong> 가정용 라이센스를 별도로 요청하실 필요가 없습니다. 동일한 일련 번호를 사용하여 가정용 컴퓨터에서 소프트웨어를 설치하고 활성화할 수 있습니다.",
    downloadYourProduct: `제품을 다운로드하여 설치하십시오. 추가 활성화가 필요하지 않습니다.`,
    emailForSerialNumPlaceholder: "연결된 이메일",
    emailForSerialNumTitle: "일련 번호와 연결된 이메일",
    emailForSerialNumTooltip: "소프트웨어 담당자, 계약 관리자 또는 소프트웨어 구매 담당자의 이메일을 입력해 주십시오.",
    ineligiblePerpetual: '이 일련 번호는 가정용으로 <b>사용할 수 없는</b> 영구 라이센스용입니다.<br/><br/>Autodesk 소프트웨어 멤버쉽은 언제 어디서나 사용할 수 있습니다. <a target="_blank" href="https://www.autodesk.co.kr/subscription">멤버쉽 혜택에 대해 더 많은 정보를 알아보십시오</a>.',
    justTypeIn: "- 일련 번호가 나와 있지 않은 경우 입력해 주십시오. -",
    msgEducationSerialNum: "교육용 일련 번호입니다.",
    msgGoToEducationComm: '<a target="_blank" href="https://www.autodesk.co.kr/education/free-software/all">교육 커뮤니티로 이동</a>',
    msgIndustryCollectionSerialNum: "<collection-name> 컬렉션에 속하는 일련 번호입니다.",
    msgNetworkSerialNum: `이 일련 번호는 <Strong>네트워크 라이센스</Strong>용이며 활성화 코드가 필요하지 않습니다. 라이센스가 올바르게 설정되어 있는지 확인하려면 네트워크 관리자에게 문의하십시오.`,
    msgSubscriptionSoftware: `이 일련 번호는 <Strong>멤버쉽 소프트웨어</Strong>용이며 활성화 코드가 필요하지 않습니다. 인터넷에 연결된 상태에서 제품을 시작하십시오. 그런 다음 <a target="_blank" href="https://www.autodesk.com/sign-in-activation-kor">로그인</a>하거나 <a target="_blank" href="https://www.autodesk.com/access-with-serial-number-kor">일련 번호를 입력</a>하십시오.`,
    msgBiCIndirectSoftware: "귀하의 라이센스에는 향상된 계정 사용 환경이 적용되므로 더 이상 활성화 코드를 사용할 필요가 없습니다. 이제 오토데스크 이메일과 암호로 로그인하기만 하면 소프트웨어를 사용할 수 있습니다(인터넷에 연결되어 있어야 함).",
    msgBicIndirectSCRole: '"귀하의 라이센스에 소프트웨어 담당자 역할이 포함되지 않습니다. 자세한 내용은 <a target="_blank" href="https://knowledge.autodesk.com/ko/customer-service/account-management/users-software/classic-user-management/hybrid-admin-roles">사용자 관리 관리자 역할</a>를 참조하십시오.',
    msgBicIndirectCMRole: '계약 관리자를 변경해도 기본 관리자는 변경되지 않습니다. Autodesk Account에서 관리자 역할을 할당할 수 있습니다(<a target="_blank" href="https://knowledge.autodesk.com/ko/customer-service/account-management/users-software/user-management/primary-admins">기본 관리자 </a>참조).',
    msgSN2010orOlder: `입력하신 일련 번호는 더 이상 지원되지 않는 이전 버전에 해당하는 번호입니다. <a target="_blank" href="https://knowledge.autodesk.com/ko/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">자격 요건을 참조해 주십시오</a>`,
    myProductNotListed: "내 제품이 목록에 없습니다.",
    noResultsMsg: "결과를 찾을 수 없습니다. XXX-XXXXXXXX 형식으로 일련 번호를 입력하십시오.",
    pageTitle: "2. 제품 정보",
    partOfCollection: "해당 제품은 <collection-name> 컬렉션에 속합니다.",
    requestCodeTitle: "요청 코드",
    requestCodetooltip: '<a target="_blank" href="https://www.autodesk.com/find-request-code-kor">요청 코드를</a> 찾는 방법',
    selectPlaceholder: "선택",
    selectProduct: "개별 제품을 선택해 주십시오.",
    selectProductPlaceholder: "제품 선택",
    selectYourProductTitle: "제품을 선택하십시오.",
    serialNumberLabel: "일련 번호",
    serialNumberPlaceholder: "이름으로 검색 - 또는 - 숫자 입력",
    serialNumbersInAccount: "계정 일련 번호",
    serialNumberTooltip: '<a target="_blank" href="https://www.autodesk.com/find-serial-number-kor">일련 번호를</a> 찾는 방법',
    yesOption: `예`,
    noOption: `아니요`,
    currentInfoTitle: "현재 정보",
    contractNumDisclaimer: `계약 번호에 하이픈(-)이 있는 경우 포함하여 기재하십시오.`,
    contractNumLabel: "계약 번호",
    contractNumTooltip: '<a target="_blank" href="https://manage.autodesk.com">Autodesk Account</a>에 로그인한 다음 청구 및 주문 영역에서 계약 번호를 찾으십시오.'
  },
  authorizationRequestScreen: {
    enterEmail: "이메일 입력",
    option1: "본인은 이 제품의 관리자, 계약 관리자 또는 소프트웨어 담당자입니다.",
    option2: "본인은 관리자, 계약 관리자 또는 소프트웨어 담당자의 대리인입니다. 관리자, 계약 관리자 또는 소프트웨어 담당자의 이메일은 다음과 같습니다.",
    pageTitle: "3. 요청 승인",
    selectOne: "하나만 선택해 주십시오."
  },
  processingScreen: {
    firstMsg: "요청하신 작업을 처리하는 중입니다.",
    takingLongerExpected: "예상보다 오래 걸리고 있습니다. 죄송하지만 조금 더 기다려 주십시오.",
    updatedMsgLonger: "아직 처리 중입니다.",
    willTakeSecs: "이 작업은 몇 초 정도 걸릴 수 있습니다..."
  },
  successScreen: {
    expirationLine: "<br/>만료일: <expiration-date>",
    infoWillBeEmailed: "이 정보는 이메일 <email>(으)로 전송됩니다.",
    pageTitle: "성공",
    prodSeatMulti: "<product-name>(<number-seats>개 시트)<br/>",
    prodSeatSingle: "<product-name> (시트 1개용)<br/>",
    pvApprovedMsg: "이전 버전에 대한 요청이 승인되었습니다.",
    pvInstruction: "다음 정보를 사용하여 소프트웨어를 설치하고 활성화하십시오.",
    reponseText: "활성화 코드: <activation-code>",
    responseText1: "가정용 라이센스 요청이 승인되었습니다.",
    responseText2: '다음 정보를 사용하여 소프트웨어를 설치하고 활성화하십시오. 설치 중에 "단품"(stand-alone)을 선택하십시오.',
    responseText3: "일련 번호: <serial-number><br/>제품 키: <product-key>",
    updateDisclaimer: `계정에 변경 사항이 적용되는 데 몇 시간 정도 걸릴 수 있습니다.`
  },
  errors: {
    emailNotAssocWithSerialNumber: "입력하신 일련 번호와 연결된 이메일이 아닙니다. ",
    enterCMSCEmail: "이 제품의 계약 관리자 또는 소프트웨어 담당자 이메일을 입력해 주십시오.",
    enterComments: "설명을 입력합니다.",
    enterEmail: "이메일을 입력하십시오.",
    enterEmailAssociated: "연결된 이메일을 입력하십시오.",
    enterFirstName: "이름을 입력하십시오.",
    enterLastName: "성을 입력하십시오.",
    enterRequestCode: "요청 코드를 입력하십시오.",
    enterSerialNumber: "일련 번호를 입력하십시오.",
    enterValidFormat: "올바른 형식으로 입력하십시오.",
    invalidAutodeskSerialNumber: '<p>올바른 Autodesk 일련 번호가 아닙니다.</p><p>다음의 인증된 출처에서 구매한 소프트웨어를 사용해야 합니다.</p><ul><li><a target="_blank" href="http://www.autodesk.com/store">오토데스크 온라인 스토어</a></li><li><a target="_blank" href="https://www.autodesk.co.kr/resellers/locate-a-reseller">공인협력업체</a></li><li><a target="_blank" href="https://www.autodesk.com/education/prepare-and-excel/authorized-academic-partner">교육 파트너</a></li></ul>',
    invalidLicenseModel: "이 제품에 잘못된 라이센스 모델이 포함되어 있습니다.",
    invalidRequestcode: "잘못된 요청 코드",
    invalidSerialNumber: "잘못된 일련 번호",
    notCMSC: "Autodesk 기록에 따르면 요청하신 분이 이 제품의 계약 관리자 또는 소프트웨어 담당자가 아닙니다.",
    oops: '죄송합니다. 요청을 처리하는 중 문제가 발생했습니다. <a target="_blank" href="https://knowledge.autodesk.com/ko/contact-support/installation-activation/activation-registration">지원 요청</a>',
    overActivation: "활성화 초과",
    productExpired: "활성화하려는 제품이 만료되었습니다.",
    reasonForActivation: "활성화 사유",
    serialNumNotAssocWithSingleLicense: "단일 사용자 라이센스와 연결된 일련 번호가 아닙니다.",
    serialNumNotFound: "일련 번호를 찾을 수 없습니다.",
    serialNumNotRegisteered: '이 일련 번호는 아직 등록되지 않았습니다. 먼저 일련 번호를 <a target="_blank" href="http://registeronce.autodesk.com/">등록</a>하십시오.'
  },
  requestFailedScreen: {
    caseError: "죄송합니다. 케이스를 제출하는 동안 문제가 발생했습니다.",
    contactOptionsBelow: `도움이 필요한 경우 아래 옵션을 사용하여 <a id="go-to-contact-us" href="javascript:void(0);">문의</a>하십시오.`,
    expiredSubsTitle: `만료된 멤버쉽`,
    expiredSubscription: `멤버쉽이 만료되었으므로 요청을 완료할 수 없습니다. 갱신 옵션은 <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">계정</a>에서 확인하거나 계정 관리자에게 문의하십시오.`,
    inactiveSubsTitle: "비활성 멤버쉽",
    noActiveSubs: `멤버쉽이 아직 활성화되지 않았거나 만료되었으므로 요청을 완료할 수 없습니다. 갱신 옵션은 <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">계정</a>에서 확인하거나 계정 관리자에게 문의하십시오.`,
    pageTitle2: "요청을 처리할 수 없습니다",
    pageTitle: "요청 실패",
    prodNotEligibleTitle: "자격 요건을 갖추지 못한 제품",
    prodNotRegisteredTitle: `제품이 등록되지 않음`,
    prodNotRegistered: `제품이 아직 등록되지 않았으므로 요청을 완료할 수 없습니다.<br><br><a target="_blank" href="https://registeronce.autodesk.com">제품 등록</a>`,
    responseText: "죄송합니다. 요청을 처리하는 중 문제가 발생했습니다."
  },
  gac: {
    welcome: {
      clickGetStarted: "활성화 코드를 받으려면 시작하기를 클릭하십시오.",
      modalTitle: "활성화 코드 받기",
      noteBullet1: `단품 영구 라이센스 또는 단품 교육용 라이센스(학생 또는 교사) 사용자가 <strong>인터넷에 연결할 수 없는 경우</strong>에만 활성화 코드가 필요합니다.`,
      noteBullet2: `<strong>인터넷에 연결된 경우에는 활성화 코드를 입력할 필요가 없습니다.</strong> 제품을 시작하고 지침에 따라 <a target="_blank" href="https://www.autodesk.com/sign-in-activation-kor">로그인</a>하거나 <a target="_blank" href="https://www.autodesk.com/access-with-serial-number-kor">일련 번호를 입력</a>하십시오.`
    },
    signInOptional: {
      title: "로그인(선택 사항)",
      message: `로그인하면 좀 더 간편하지만 필수 사항은 아닙니다.`
    },
    overActScreen: {
      actAgainLabel: "다시 활성화하는 이유를 선택하십시오.",
      pageTitle: "3. 초과 활성화 이유 ",
      reason1: "새 컴퓨터",
      reason2: "컴퓨터 도난",
      reason3: "소프트웨어 재설치",
      reason4: "다른",
      responseText: "이 일련 번호는 이미 활성화되었습니다.",
      selectReason: "이유 선택"
    },
    requestFailedScreen: {
      gacExportControlBlock: '"Autodesk 제품을 사용할 수 있는 권한이 있는지 표준 수출 심사가 진행 중입니다. 몇 분 정도 걸릴 수 있습니다. 잠시 후 다시 시도해 주십시오. 자세한 내용은 Autodesk <a target="_blank" href="https://www.autodesk.com/company/legal-notices-trademarks/compliance">수출 규정 준수 정책</a>을 참고하십시오."',
      gacProductKeyAndSerialNotFound: '일치하는 제품을 찾지 못했습니다. 올바른 일련 번호를 입력했는지 확인하십시오. 자세한 내용은 <a target="_blank" href="https://knowledge.autodesk.com/ko/customer-service/download-install/activate/find-serial-number-product-key">일련 번호 및 제품 키 찾기</a>를 참조하십시오. ',
      gacAssetNotFound: '일련 번호를 올바르게 입력했는지 확인하십시오. 최근에 구매한 제품인 경우 처리 시간이 다소 늘어날 수 있습니다. 자세한 내용은 <a target="_blank" href="https://knowledge.autodesk.com/ko/customer-service/download-install/download/subscription-downloads#missing">제품이 보이지 않으십니까?</a>를 참조하십시오.',
      gacContactNotFound: "이메일을 찾을 수 없습니다. 이 일련 번호에 대한 올바른 이메일 주소를 입력했는지 확인하십시오.",
      gacGetAssetActivationCode: "오류가 발생했습니다. <b>다시 제출</b>을 클릭합니다. 여러 번 시도한 후에도 이 문제가 해결되지 않으면 지원 팀에 문의하십시오.",
      gacFlexShortRequestCodeInvalid: "유효한 요청 코드가 아닙니다. 코드를 올바르게 입력했는지 확인하십시오."
    }
  },
  hula: {
    welcome: {
      clickGetStarted: "가정용 일련 번호를 받으려면 시작하기를 클릭하십시오.",
      intro: "가정용 라이센스를 받으려면 다음의 간단한 단계를 수행해 주십시오.",
      modalTitle: "가정용 라이센스 요청",
      noteBullet1: '가정용 라이센스는 케어 플랜에 가입된 네트워크 라이센스 및 복수 사용자 멤버쉽에 포함된 <a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-kor">적용 대상 제품</a>에 대해 제공됩니다.',
      noteBullet2: "단일 사용자 멤버쉽에는 가정용 라이센스가 자동으로 포함됩니다. 동일한 일련 번호를 사용하여 가정용 컴퓨터에서 소프트웨어를 설치하고 활성화할 수 있습니다."
    },
    processInfoScreen: {
      hulaEligibleVersionMsg: '위에 나열된 적격한 버전에만 해당됩니다. <a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-kor">자격 요건 보기</a>',
      crossGradeHulaMessage: `여기서는 귀하의 요청을 처리할 수 없습니다. 선택한 버전에 대한 가정용 라이센스를 받으려면 <a id="go-to-create-case" href="javascript:void(0);">케이스를 작성해 주십시오.</a> 요청을 처리하는 데는 영업일 기준으로 2일 정도 소요됩니다.`
    },
    errors: {
      tokenFlexSerialNumber: `TokenFlex 일련 번호를 입력하셨습니다. 가정용 라이센스를 요청하려면 <strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong>으로 Autodesk 프리미어 전문가에게 이메일을 보내 주십시오.`
    },
    requestFailedScreen: {
      hulaEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-kor">자격 요건 보기</a>',
      hulaIneligible: "가정용 라이센스를 사용할 수 없는 제품이므로 요청을 완료할 수 없습니다.",
      exportControlBlockOREmbergoList: `귀하께서 오토데스크 제품 사용 자격을 갖추셨는지 표준 수출 스크리닝 중이며, 몇 분 정도 소요될 수 있습니다. 자세한 내용은 오토데스크 <a href="https://www.autodesk.com/company/legal-notices-trademarks/compliance">수출 규정 준수 정책</a>을 참고하십시오.`
    }
  },
  pv: {
    welcome: {
      clickGetStarted: "소프트웨어의 이전 버전에 액세스하려면 시작하기를 클릭하십시오.",
      intro: "소프트웨어의 이전 버전을 구하려면 다음의 빠른 단계를 따르십시오.",
      modalTitle: "이전 버전 요청",
      noteBullet1: '멤버쉽을 보유한 경우 귀하의 <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">계정</a>에 로그인하여 필요로 하는 이전 버전을 다운로드하십시오.',
      noteBullet2: '케어 플랜에 가입된 단품(stand-alone) 라이센스를 보유한 경우 이 방법을 사용해 <a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-kor">적격한</a> 제품의 이전 버전을 요청하십시오.'
    },
    processInfoScreen: {
      noPvAvailable: '요청하신 제품의 이전 버전이 지원되지 않습니다. 자세한 내용은 Autodesk의 <a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-kor">이전 버전 정책</a>을 참조하십시오.',
      pvEduUserMsg: '교육용 라이센스를 보유하고 계십니다. <a target="_blank" href="https://www.autodesk.com/education/free-software/all">교육 커뮤니티</a>를 방문하시면 최대 3개까지 이전 버전을 다운로드할 수 있습니다.',
      pvEligibleVersionMsg: '위에 나열된 적격한 버전에만 해당됩니다. <a target="_blank" href="https://knowledge.autodesk.com/ko/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">자격 요건 보기</a>',
      pvMultiUserSubsMsg: `복수 사용자 멤버쉽을 보유하고 계십니다. 이전 버전의 일련 번호는 <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">계정</a>에 표시되어 있습니다.`,
      pvNetworkMaintenanceUserMsg: `네트워크 라이센스를 보유하고 계십니다. 이전 버전의 일련 번호는 <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">계정</a>에 표시되어 있습니다.`,
      pvPerpetualUserMsg: '이 제품에 대한 영구 라이센스를 보유한 경우 이전 버전에 액세스할 수 없습니다.<br/><br/>멤버쉽 고객은 이전 버전에 액세스할 수 있습니다. <a target="_blank" href="http://www.autodesk.co.kr/subscription">멤버쉽 혜택에 대해 자세히 알아보십시오.</a>',
      pvSingleUserSubsMsg: '단일 사용자 멤버쉽을 보유하고 계십니다. 최대 3개까지 이전 버전에 액세스하려면 귀하의 <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">계정</a>에서 원하는 제품을 지정하십시오("일련 번호 가져오기" 링크 찾기).',
      serialNumberCurrentLabel: "현재 일련 번호",
      versionRequestingLabel: "요청한 버전"
    },
    errors: {
      tokenFlexSerialNumber: `TokenFlex 일련 번호를 입력하셨습니다. 이전 버전 라이센스를 요청하려면 <strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong>으로 Autodesk 프리미어 전문가에게 이메일을 보내 주십시오.`
    },
    requestFailedScreen: {
      pvEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-kor">자격 요건 보기</a>',
      pvInactiveSubscription: '이 제품에 대한 멤버쉽이 귀하의 <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">계정</a>에서 활성화되어 있지 않아 요청을 처리할 수 없습니다.',
      pvIneligible: "보유하신 제품이 이전 버전 라이센스를 사용할 수 있는 요건을 갖추지 못해 요청을 처리할 수 없습니다."
    }
  },
  cm: {
    welcome: {
      clickGetStarted: "계약 관리자를 변경하려면 시작하기를 클릭하십시오.",
      modalTitle: "계약 관리자 변경",
      noteBullet1: "자동 갱신되지 않는 케어 플랜 및 멤버쉽의 경우 계약 관리자를 변경할 수 있습니다.",
      noteBullet2: "자동 갱신 멤버쉽을 보유한 경우 계약 관리자를 변경하려면 멤버쉽을 취소하고 새로 시작해야 합니다."
    },
    processInfoScreen: {
      cmEmailPlaceholder: "계약 번호와 연결됨",
      contractNumDisclaimer: `계약 번호에 하이픈(-)이 있는 경우 포함하여 기재하십시오.`,
      contractNumLabel: "계약 번호",
      contractNumTooltip: '<a target="_blank" href="https://manage.autodesk.com">Autodesk Account</a>에 로그인한 다음 청구 및 주문 영역에서 계약 번호를 찾으십시오.',
      currentCmEmailLabel: "현재 계약 관리자 이메일",
      newCmEmailLabel: "새 계약 관리자 이메일",
      newCmNameLabel: "새 계약 관리자 이름",
      newCmPhoneLabel: "새 계약 관리자 전화 번호",
      pageTitle2: "3. 새 정보",
      pageTitle: "2. 현재 정보",
      phoneNumPlaceholder: "지역 코드 및 번호 포함"
    },
    authorizationRequestScreen: {
      option1: "본인은 계약 관리자이거나 이 요청을 수행하기 위해 이 멤버쉽을 소유한 회사로부터 적절한 권한을 부여받았음을 확인합니다.",
      confirmLabel: "이 요청을 제출할 수 있는 권한이 있는지 확인하십시오",
      pageTitle: "4. 이 요청 승인"
    },
    successScreen: {
      cmWillReceiveEmail: `새 계약 관리자에게는 자세한 지침이 이메일로 전송됩니다.`,
      emailWillBeSent: "<email>(으)로 이메일 확인이 전송됩니다.",
      responseText4: `계약 번호 <contract-number>에 새 계약 관리자가 있습니다.`
    },
    errors: {
      contractNumNotFound: "계약 번호를 찾을 수 없습니다.",
      emailNotAssociatedWithcontractNum: "이 이메일은 위의 계약 번호와 연결되어 있지 않습니다.",
      enterContractNum: "계약 번호를 입력하십시오."
    },
    requestFailedScreen: {
      autoRenewSubs: "Autodesk의 기록에 따르면 귀하는 자동 갱신 멤버쉽을 보유하고 있습니다. 계약 관리자를 변경하려면 멤버쉽을 취소하고 새로 시작해야 합니다.",
      autoRenewSubsTitle: "멤버쉽 자동 갱신",
      inactiveContract: "계약이 더 이상 활성 상태가 아니므로 요청을 처리할 수 없습니다.",
      inactiveContractTitle: "비활성 계약"
    }
  },
  sc: {
    welcome: {
      clickGetStarted: "소프트웨어 담당자를 변경하려면 시작하기를 클릭하십시오.",
      modalTitle: "소프트웨어 담당자 변경",
      noteBullet1: "이 방법으로 케어 플랜 및 멤버쉽의 소프트웨어 담당자를 변경할 수 있습니다(교육용 제품 제외)."
    },
    processInfoScreen: {
      currentScEmailLabel: "현재 소프트웨어 담당자 이메일",
      newScEmailLabel: "새 소프트웨어 담당자 이메일",
      newScNameLabel: "새 소프트웨어 담당자 이름",
      newScPhoneLabel: "새 소프트웨어 담당자 전화 번호",
      scEmailPlaceholder: "일련 번호와 연결됨",
      importantInformation: "중요 정보"
    },
    authorizationRequestScreen: {
      option1: "본인은 계약 관리자 또는 소프트웨어 담당자거나 이 요청을 수행하기 위해 이 멤버쉽을 소유한 회사로부터 적절한 권한을 부여받았음을 확인합니다."
    },
    successScreen: {
      responseText4: `일련 번호 <serial-number>에 새 소프트웨어 담당자가 있습니다.`,
      scWillReceiveEmail: `새 소프트웨어 담당자에게는 자세한 지침이 이메일로 전송됩니다.`
    },
    errors: {
      emailNotAssociatedWithSerialNum: "이 이메일은 위의 일련 번호와 연결되어 있지 않습니다.",
      tokenFlexSerialNumber: `TokenFlex 일련 번호를 입력하셨습니다. 소프트웨어 담당자를 변경하려면 <strong><a href="mailto:premier@autodesk.com">premier@autodesk.com</a></strong> 으로 Autodesk 프리미어 제품 전문가에게 이메일을 보내 주십시오.`
    },
    requestFailedScreen: {
      serialNumberIneligle: "소프트웨어 담당자를 변경할 수 있는 일련 번호가 아니기 때문에 요청을 처리할 수 없습니다.",
      serialNumberIneligleTitle: "일련 번호 부적격"
    }
  },
  ccna: {
    welcome: {
      clickGetStarted: "회사의 연락처 정보를 변경하려면 시작하기를 클릭하십시오.",
      modalTitle: "회사 이름 또는 주소 변경",
      noteBullet1: "<strong>계약 관리자</strong>는 회사 이름과 주소만 변경할 수 있습니다.",
      noteBullet2: '<strong>이 과정은 소유권 이전 과정이 아닙니다.</strong> 라이센스를 새 소유자에게 이전하려면 <a target="_blank" href="https://knowledge.autodesk.com/ko/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses">라이센스 이전 요청</a>을 제출해야 합니다.'
    },
    processInfoScreen: {
      reviewInfoTitle: "계정 정보 검토",
      currentInfoTitle: "현재 정보",
      current: "현재: ",
      pageTitle2: "새 정보 입력",
      pageTitleValidateAddr: "주소 검증",
      pageTitleConfirmChanges: "변경 사항 확인",
      changeInfoLabel: "어떤 정보를 변경하시겠습니까?",
      addressOption: "주소",
      nameOption: "회사 이름",
      nameAndAddressOption: "회사 이름과 주소",
      newTaxIdLabel: "새 세금 ID 또는 EIN도 가지고 계십니까?",
      msgTOLS: '위에 응답해 주신 내용에 따라 라이센스를 새로운 소유자에게 이전하려면 <a target="_blank" href="https://knowledge.autodesk.com/ko/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses">라이센스 양식</a> 을 작성해야 합니다. 지원이 필요하면 <Strong>아래 고객 지원 서비스</Strong>에 문의해 주십시오.',
      unauthorizedUser: "귀하에게 이 계약을 변경할 수 있는 권한이 없습니다.",
      msgAutoRenew: '일부 클라우드 기반 소프트웨어 계약 및 자동 갱신 반복 청구를 위한 회사 이름 또는 주소 변경은 온라인으로 수행할 수 없습니다. <a target="_blank" href="https://knowledge.autodesk.com/ko/customer-service/account-management/account-profile/change-company-name-and-address">회사 이름 또는 주소</a>를 변경하려면 다음 절차를 수행하십시오.',
      msgExpiredContract: "이 계약은 만료되었습니다.",
      notEligible: "이 계약은 유효하지 않습니다.",
      changingInfoFor: "정보를 변경할 계약 번호: <contract-number>",
      companyName: "회사 이름",
      accountCSN: `계정 CSN`,
      streetAddress: "상세 주소",
      city: "구/군/시",
      state: "시/도",
      postalCode: "우편 번호 ",
      country: "국가",
      validateAddDisclaimer: "올바른 주소명이 아래 강조 표시되어 있습니다. 귀하가 입력한 주소를 선택하면 처리 시간이 길어질 수 있습니다.",
      confirmDisclaimer: "제출하기 전에 변경 사항에 오류가 없는지 검토해 주십시오. 이전 화면으로 돌아가 잘못된 정보를 변경할 수 있습니다.",
      recommendedAddr: "올바른 주소명",
      enteredAddr: "입력한 주소",
      changeWillbeAppliedFor: "변경 사항이 적용될 계약 번호: <contract-number>",
      new: "새 정보",
      old: "이전 정보",
      emailWillBeSent: "다음 주소로 이메일 확인이 전송됩니다. <email>"
    },
    successScreen: {
      emailWillBeSent: "다음 주소로 이메일 확인이 전송됩니다. <email>",
      changeAppliedFor: "계약 번호 <contract-number>의 계약이 다음과 같이 업데이트되었습니다.",
      nonCleansedAddrMsg: "케이스 번호가 포함된 이메일 확인이 곧 전송됩니다. 이 이메일을 보관해 두십시오..<br><br><strong>영업일 기준으로 2일 이내에 제출해 주신 케이스에 대해 응답을 드리겠습니다..</strong><br><br>한 시간 이내에 확인 이메일을 받지 못한 경우 정크 메일 폴더를 확인하거나 네트워크 관리자에게 문의하십시오."
    },
    errors: {
      contractNumNotFound: "계약 번호를 찾을 수 없습니다.",
      invalidContractNum: "잘못된 계약 번호",
      enterContractNum: "계약 번호를 입력하십시오."
    }
  }
};